<template lang="pug">
section#testimonios.testimonials
    .row
        .col-1
        .col-10.mt-5.text-uppercase.text-center.text-white
            h4.te-title {{ title }}
        .col-1
        .col-1
        .col-1
            a.carousel-control-prev(href='#carouselTestimonal', role='button', data-slide='prev')
                span.fa.fa-chevron-left.fa-4x
        .col-8.mt-3.mb-5
            #carouselTestimonal.carousel.slide(data-ride='carousel', :data-interval='interval')
                .carousel-inner.row.w-100.mx-auto(role='listbox')
                    .col-sm-4.carousel-item(v-for='(t,idx) in testimonials' :class='idx === 0 ? "active" : ""')
                        oc-te-card(:contentData='t' :key='idx')
        .col-1
            a.carousel-control-next(href='#carouselTestimonal', role='button', data-slide='next')
                span.fa.fa-chevron-right.fa-4x
        .col-1           
</template>

<script>
import MODAL from '@/constants/modal-types'
import OcTeCard from '@/components/landing/testimonials/TeCard.vue'

export default {
    components: {
        OcTeCard
    },
    data () {
        return {
            title: 'Testimonios',
            interval: 25000,
            testimonials: [
                { 
                    imgSrc: `${HOMEURL}img/te/list/1/avatar.png`,
                    typeToShow: MODAL.IMAGE,
                    toShow: `${HOMEURL}img/te/list/1/toshow.jpg`,
                    axnText: 'Leer carta',
                    personName: 'Dra. Mirna Juraidini',
                    fontAwesomeIcon: 'fa-envelope-open'
                },
                { 
                    imgSrc: `${HOMEURL}img/te/list/2/avatar.png`,
                    typeToShow: MODAL.IMAGE,
                    toShow: `${HOMEURL}img/te/list/2/toshow.png`,
                    axnText: 'Ver comentario',
                    personName: 'María Luisa',
                    fontAwesomeIcon: 'fa-comments'
                },
                { 
                    imgSrc: `${HOMEURL}img/te/list/3/avatar.png`,
                    typeToShow: MODAL.IMAGE,
                    toShow: `${HOMEURL}img/te/list/3/toshow.jpg`,
                    axnText: 'Ver comentarios',
                    personName: 'Movimiento "Tu Primer Millón"',
                    fontAwesomeIcon: 'fa-comments'
                },
                { 
                    imgSrc: `${HOMEURL}img/te/list/4/avatar.png`,
                    typeToShow: MODAL.IMAGE,
                    toShow: `${HOMEURL}img/te/list/4/toshow.jpg`,
                    axnText: 'Ver comentarios',
                    personName: 'Anónimo',
                    fontAwesomeIcon: 'fa-envelope-open'
                },
                { 
                    imgSrc: `${HOMEURL}img/te/list/4/avatar.png`,
                    typeToShow: MODAL.VIDEO,
                    toShow: `https://www.youtube.com/embed/Ow9KqF6HDnY`,
                    axnText: 'Ver video',
                    personName: 'Anónimo',
                    fontAwesomeIcon: 'fa-play-circle'
                }
            ]
        }
    },
    mounted () {
        this.$nextTick( () => {
            $('#carouselTestimonal').on('slide.bs.carousel', function (e) {
                var $e = $(e.relatedTarget);
                var idx = $e.index();
                var itemsPerSlide = 3;
                var totalItems = $('#carouselTestimonal .carousel-inner .carousel-item').length;
                if (idx >= totalItems-(itemsPerSlide-1)) {
                    var it = itemsPerSlide - (totalItems - idx);
                    for (var i=0; i<it; i++) {
                        // append slides to end
                        if (e.direction=="left") {
                            $('#carouselTestimonal .carousel-inner .carousel-item').eq(i).appendTo('#carouselTestimonal .carousel-inner');
                        }
                        else {
                            $('#carouselTestimonal .carousel-inner .carousel-item').eq(0).appendTo('#carouselTestimonal .carousel-inner');
                        }
                    }
                }
            })
        })
    }
}
</script>




// WEBPACK FOOTER //
// src/components/landing/Testimonials.vue